<template>
  <div class="content-wrapper" id="appcourier">
    <div class="container">
      <v-row>
        <v-col>
          <div id="modalPrint">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">Impresión de Runsheet</h4>
                  <p></p>
                </div>
                <div class="modal-body" id="billdata" v-if="rs != null">
                  <p></p>
                  <div class="row">
                    <div class="col-sm-6">
                      <img src="images/logo.jpg" width="150" height="45" />
                    </div>

                    <div class="col-sm-6">
                      <div class="text-center">
                        <h3>RUNSHEET</h3>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <label>Fecha : </label><span>{{ rs.fecha }}</span
                      ><br />
                      <label>Courier : </label
                      ><span> {{ rs.courier.nombre }}</span
                      ><br />
                      <label>Hoja : </label><span>{{ rs.hoja }}</span
                      ><br />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12" style="font-size: 11px">
                      <table
                        class="table table-bordered"
                        style="font-size: 10px"
                      >
                        <thead>
                          <tr class="encabezado">
                            <th>GUIA</th>
                            <th>NOMBRE</th>
                            <th>INFO</th>
                            <th>RECIBIDO</th>
                            <th>FIRMA</th>
                            <th>HORA</th>
                            <th>OBSERVACIONES</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in items" :key="item.id">
                            <td>
                              <barcode v-bind:value="item != null ? item.guia_interna: ''"  v-bind:height="15" v-bind:displayValue="false" v-bind:marginTop="1" v-bind:marginBottom="1">
                                Error al generar barcode
                              </barcode>
                              {{ item.guia_interna }}<br />
                              {{ item.guia_proveedor }}
                              </td>
                            <td>
                              {{ item.empresa_c }} <br />
                              {{ item.contacto_c }} <br />
                              Telefono: {{item.telefono  }}
                            </td>
                            <td>
                              Dirección: {{ item.direccion1_c }}
                              {{ item.direccion2_c }} {{ item.direccion3_c
                              }}<br />
                              Tipo: {{ item.tipo }}<br />
                              Paquetes: {{ item.piezas }}
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <hr class="border" />
                <div class="modal-footer">
                  <v-btn color="blue" @click="imprimirGuia()" outlined
                    >Imprimir</v-btn
                  >
                  <p></p>
                </div>
              </div>
            </div>
            <p></p>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import apicon from "../plugins/apicon";
import VueBarcode from 'vue-barcode';
import $ from "jquery";
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  components: {
    'barcode': VueBarcode
  },
  created: function () {},
  data() {
    return {
      rs: null,
      items: [],
      isCliente: 1,
    };
  },
  methods: {
    fillDatosRunsheet: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "runsheet/" + this.id)
        .then((result) => {
          this.rs = result;
        });
    },
    fillDatosItems: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "guiasrunsheet/" + this.id)
        .then((result) => {
          this.items = result;
        });
    },
    imprimirGuia: function () {
      var mywindow = window.open("", "tracking div", "height=400,width=600");
      mywindow.document.write(
        '<html><head><link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css"><link rel="stylesheet" href="css/print.css" media="print" /><link rel="stylesheet" href="css/bootstrap-print.min.css" media="print"/></head><body onload="window.print()">'
      );
      mywindow.document.write($("#billdata").html());
      mywindow.document.write("</body></html>");
      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10
      setTimeout(function () {
        mywindow.close();
      }, 1000);
    },
  },
  mounted: async function () {
    apicon.setAuthHeaders();
    await this.fillDatosRunsheet();
    await this.fillDatosItems();
    this.isCliente = localStorage.getItem("cliente");
  },
};
</script>
<style scoped src="bootstrap/dist/css/bootstrap.css">
</style>
